import Keycloak from "keycloak-js";
import { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { AppContext } from "../../App.js";
import { useMutationClient } from "../hooks.js";

const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID;
const SSO_URL = process.env.REACT_APP_SSO_URL;
const SSO_REALM = process.env.REACT_APP_SSO_REALM;
const SSO_REDIRECT_URI = process.env.REACT_APP_SSO_REDIRECT_URI;

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { actions } = useContext(AppContext);
  const mutationClient = useMutationClient();

  const mutation = useMutation((data) => mutationClient.post("login", data), {
    onSuccess: (data) => {
      if (data.status === 200) {
        actions.setToken(data.data.token);
      }
    },
  });

  let errorMessage;

  if (mutation.isError && mutation.error) {
    errorMessage = mutation.error.response.data.error.message;
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        mutation.reset();
        mutation.mutate({ email, password });
      }}
    >
      <div className="mb-4">
        <label className="fw-bold mb-2">Correo electrónico</label>
        <input
          className="form-control form-control-lg"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={mutation.isLoading}
        />
      </div>

      <div className="mb-4">
        <label className="fw-bold mb-2">Contraseña</label>
        <input
          className="form-control form-control-lg"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={mutation.isLoading}
        />
      </div>

      {errorMessage ? (
        <div className="mb-3 text-center text-danger">{errorMessage}</div>
      ) : null}

      <div className="d-grid mb-2">
        <input
          type="submit"
          className="btn btn-primary btn-lg mb-3"
          value="Iniciar sesión"
          disabled={mutation.isLoading}
        />

        <Link to="/password/recover" className="text-center mb-2">
          Recuperar contraseña
        </Link>

        <Link to="/signup" className="text-center">
          Crear cuenta
        </Link>
      </div>
    </form>
  );
};

const SSOLogin = () => {
  const [keycloak, setKeycloak] = useState(null);
  const [initError, setInitError] = useState(false);
  const initRef = useRef(false);

  const mutationClient = useMutationClient();
  const { actions } = useContext(AppContext);

  const mutation = useMutation(
    (access_token) => mutationClient.post("auth/sso", { access_token }),
    {
      onSuccess: (data) => {
        if (data.status === 200) {
          actions.setToken(data.data.token);
        }
      },
    }
  );

  const mutateRef = useRef(mutation.mutate);
  mutateRef.current = mutation.mutate;

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    const kc = new Keycloak({
      url: SSO_URL,
      realm: SSO_REALM,
      clientId: SSO_CLIENT_ID,
    });

    kc.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      checkLoginIframe: false,
      redirectUri: SSO_REDIRECT_URI,
    })
      .then((authenticated) => {
        setKeycloak(kc);
        if (authenticated && kc.token) {
          mutateRef.current(kc.token);
        }
      })
      .catch(() => {
        setInitError(true);
      });
  }, []);

  if (mutation.isLoading || mutation.isSuccess) {
    return (
      <div className="text-center">
        <span className="btn btn-primary btn-lg mx-auto disabled">
          Iniciando sesión...
        </span>
      </div>
    );
  }

  if (mutation.isError || initError) {
    return (
      <div className="p-2 bg-danger text-white rounded text-center">
        Hubo un error al iniciar sesión
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => keycloak.login({ redirectUri: SSO_REDIRECT_URI })}
      disabled={!keycloak}
      className="btn btn-primary btn-lg mx-auto"
    >
      {keycloak ? "Iniciar sesión con mi Cuenta Los Héroes" : "Cargando..."}
    </button>
  );
};

export default function LoginPage() {
  return (
    <div
      className="row d-flex justify-content-center"
      style={{ height: "100vh" }}
    >
      <div className="col-12 col-lg-4 mt-5">
        <div className="card shadow-sm mt-5">
          <div className="card-body">
            <div className="text-center mb-4">
              <img src="/Logo-LH.png" width="150" />
            </div>

            {SSO_CLIENT_ID ? (
              <div className="text-center">
                <SSOLogin />
              </div>
            ) : (
              <>
                <h4 className="text-center mb-4">
                  Iniciar sesión <br />
                  Reserva de estacionamientos
                </h4>
                <LoginForm />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
